import * as React from 'react';
import { Col, Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { IStep } from 'src/model';
import { WorkspaceStepClosureWithGlobalContext } from './WorkspaceStepClosure';
import { WorkspaceStepItemWithGlobalContext } from './WorkspaceStepItem';

interface IWorkspaceStepListProps {
  stepList: IStep[];
  handleStepListChange: (step: IStep) => void;
}

export const WorkspaceStepList: React.SFC<IWorkspaceStepListProps> = ({
  handleStepListChange,
  stepList,
}) => (
  <>
    <Row className='d-flex align-items-center'>
      <Svg width={48} fill='dark' src='comments' />
      <h4 className='text-uppercase text-dark ml-4'>{`étapes : ${
        stepList.filter(
          (step: IStep) =>
            step.meta.status === 'started' || step.meta.status === 'validated'
        ).length
      }/${stepList.length}`}</h4>
    </Row>
    <Row className='pr-5'>
      <Col className='rounded bg-white p-3 mt-3' md='12'>
        {stepList.map((step: IStep, key: number) => (
          <WorkspaceStepItemWithGlobalContext
            key={key}
            step={step}
            handleStepListChange={handleStepListChange}
          />
        ))}
        <WorkspaceStepClosureWithGlobalContext stepList={stepList} />
      </Col>
    </Row>
  </>
);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectWorkspace/WorkspaceStepList/WorkspaceStepList.tsx